module.exports = __webpack_public_path__ + "img/EveryoneSaved.65da6f4c.jpeg";